
import { required } from 'vuelidate/lib/validators'

export default {
  occurrence: {
    content: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/book-occurrence/form/resources/validations.js